import React from "react";

import { MenuItem, Select, Stack, Typography } from "@mui/material";

import { useEmailsContext } from "../context/Email-context";

interface Props {}

export const Sort: React.FC<Props> = () => {
  const { sort, onSortChange } = useEmailsContext();
  const sortOptions = [
    { value: "desc", label: "Newest" },
    { value: "asc", label: "Oldest" }
  ];

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>Sort by:</Typography>
      <Select
        size="small"
        value={sort}
        onChange={(e) => onSortChange(e.target.value as "desc" | "asc")}
        sx={{ borderRadius: "12px", minWidth: 120, height: "32px" }}
      >
        {sortOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
